import { render, staticRenderFns } from "./UserConnections.vue?vue&type=template&id=44ca6e2f"
import script from "./UserConnections.vue?vue&type=script&lang=js"
export * from "./UserConnections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports